import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import ClassificacaoRequisitoService from "service/auditoria5s/ClassificacaoRequisitoService";
import { TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const classificacaoRequisito = new ClassificacaoRequisitoService();

export default function ClassificacaoRequisitoListagem() {

    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        descricao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={classificacaoRequisito} urlService="/classificacaoRequisito" tituloPagina={'Classificações de requisitos'} defaultFilters={defaultFilters} showClearFilterButton nome="classificacaoRequisito">
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}/>
            <Column field="descricao" header="Descrição" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
        </BaseListagem>
    )
}
